import React, { useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import ModernTabNavigation from '../../components/ModernTabNavigation'
import AdminEvent from './AdminEvent'
import AdminAnouncement from './AdminAnnouncement'
import HumanEvent from '../AdminSystem/HumanEvent'
import { APPNAME } from 'app/constants/APIKEYS'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;

  @media (max-width: 768px) {
    padding: 0 5px 20px;
  }
`

export const AdminEventsPage = () => {
	const { pathname } = useLocation()

	const items = useMemo(
		() => [
			{
				title: '공지 관리',
				link: '/events/announcements',
			},
			{
				title: '이벤트 관리',
				link: '/events/event',
			},
			{
				title: '휴먼 이벤트',
				link: '/events/human-event',
			},
		],
		[]
	)

	const renderContent = () => {
		switch (pathname) {
			case '/events':
			case '/events/announcements':
				return <AdminAnouncement />
			case '/events/event':
				return <AdminEvent />
			case '/events/human-event':
				return <HumanEvent />
			default:
				return <AdminAnouncement />
		}
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>{APPNAME} ADMIN - 공지/이벤트</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<StyledContent>{renderContent()}</StyledContent>
		</StyledLayout>
	)
}

